/**
 * AI API module — issue analysis and visual diff analysis.
 */
import type { AIVisualAnalysis, AISuggestion } from '@overlayqa/shared';
import { fetchApi } from './client';
import { log } from '@/lib/logger';
import { SCREEN_READ_TIMEOUT_MS } from './requestTimeout';

log.info('[api/ai] Module loaded');

export const aiApi = {
  analyzeIssue: (token: string | undefined, description: string) =>
    fetchApi<AISuggestion>('/ai/analyze-issue', {
      token,
      method: 'POST',
      body: JSON.stringify({ description }),
    }),

  // Visual Analysis Methods
  analyzeVisual: (token: string | undefined, data: {
    ticketId: string;
    figmaImageUrl: string;
    screenshotUrl: string;
    context: {
      pageUrl: string;
      viewportWidth: number;
      viewportHeight: number;
      figmaFrameName?: string;
      devicePixelRatio?: number;
    };
  }) => fetchApi<{ analysisId: string; status: string }>('/ai/analyze-visual', {
    token,
    method: 'POST',
    body: JSON.stringify(data),
  }),

  getAnalysis: (token: string | undefined, ticketId: string) =>
    fetchApi<AIVisualAnalysis>(`/ai/analysis/${ticketId}`, { token, timeoutMs: SCREEN_READ_TIMEOUT_MS }),

  reanalyzeTicket: (token: string | undefined, ticketId: string, triggerMode: 'manual' | 'automatic' | 'batch' = 'manual') =>
    fetchApi<{ analysisId: string; status: string; triggerMode: string }>(`/ai/reanalyze/${ticketId}`, {
      token,
      method: 'POST',
      body: JSON.stringify({ triggerMode }),
    }),
};
